import React from 'react';

import scss from './CustomerSection.module.scss';

const CustomerSection = ({ title, children }) => {
  return (
    <div className={scss.customerSection}>
      <h3 className={scss.title}>{title}</h3>
      <div className={scss.content}>{children}</div>
    </div>
  );
};

export default CustomerSection;
